// src/components/PrivateRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// Admin route guard. `to` is the login page: the admin login at
// /rdj-api/login for both admins (Classic since 2026-10-01). The page asked
// for goes along as state.from so the login can return to it.
const PrivateRoute = ({ children, to = "/rdj-api/login" }) => {
  const location = useLocation();
  let token = null;
  try {
    token = localStorage.getItem("token");
  } catch {
    token = null;
  }
  if (!token) {
    try {
      localStorage.removeItem("token");
    } catch {
      // storage blocked: nothing to clear
    }
    return <Navigate to={to} replace state={{ from: location }} />;
  }

  return children;
};

export default PrivateRoute;
